export const text = {
  TITLE: 'ICD-10 codes',
  NO_CODES: 'No ICD-10 codes',
  PLACEHOLDER: 'Search ICD-10',
  EDIT: 'Edit',
  CANCEL: 'Cancel',
  SAVE: 'Save',
}

export const styles = {
  SEARCH_RESULTS_HIDDEN: { maxHeight: 366 },
  DETAILS_HEIGHT: { maxHeight: 524 },
  DETAILS_NO_CODES_HEIGHT: { height: 100 },
  DETAILS_TOP_ERROR_STYLE: { top: 108 },
  READ_ONLY_LIST_HEIGHT_STYLE: { maxHeight: 227 },
  EDIT_BUTTON_STYLE: { height: 40, width: 55 },
  EDIT_BUTTON_EMPTY_SECTION_STYLE: { height: 40, width: 55, marginBottom: 10 },
  CANCEL_BUTTON_STYLE: { height: 38, width: 104, padding: 0 },
  SAVE_BUTTON_STYLE: { height: 40, width: 104, marginLeft: 16 },
}
